define.alias("@embroider/util/services/ensure-registered", "calendar/services/-ensure-registered");